import React from 'react';
import { M130ProductDetailModule } from '~/lib/data-contract';
import { ModuleFeatureContext } from '~/templates/blocks/context/ModuleFeatureContext';
import ProductDetailDataWrapper from './product-details/product-detail-data-wrapper';

const M130ProductDetail = (props: M130ProductDetailModule) => {
    return (
        <ModuleFeatureContext.Provider value={{ reserveInStore: false }}>
            <ProductDetailDataWrapper {...props} />
        </ModuleFeatureContext.Provider>
    );
};

export default M130ProductDetail;